export default function NotFound(){
    return(
        <div className="login-container container padded-container">
            <img className="login-logo" src="./logo.png" alt="logo" />
            <h1 className="login-heading">Ops! Error 404 The Page You are Looking for is not found.</h1>
            <h2 className="login-subheading">Try checking the url for typos.</h2>
        </div>
    );
}